import { useState } from 'react';
import { ScrollRevealWrapper } from '../../../components/feature/ScrollRevealWrapper';

interface Depoimento {
  id: number;
  nome: string;
  profissao: string;
  cidade: string;
  resultado: string;
  resultadoIcone: string;
  depoimento: string;
  conquistas: string[];
  thumbnail: string;
  youtubeId: string;
  estrelas: number;
  tempoMetodo: string;
}

const depoimentos: Depoimento[] = [
  {
    id: 1,
    nome: 'Mariana Rodrigues',
    profissao: 'CEO & Fundadora',
    cidade: 'São Paulo, SP',
    resultado: 'De funcionária a CEO de empresa 7 dígitos',
    resultadoIcone: 'ri-building-2-line',
    depoimento: 'Fiz coaching, terapia, cursos online — nada funcionava de verdade. O método da Bia foi diferente porque trabalhou nos padrões mentais na raiz. Em menos de um ano, fundei minha própria empresa e faturamos R$ 2M no primeiro ciclo. Isso não é sorte, é reprogramação.',
    conquistas: ['Empresa própria com R$ 2M/ano', '12 funcionários contratados', 'Liberdade de horário e local'],
    thumbnail: 'https://public.readdy.ai/ai/img_res/598721b590a82517e71024adabd00643.jpg',
    youtubeId: 'dQw4w9WgXcQ',
    estrelas: 5,
    tempoMetodo: '9 meses no método',
  },
  {
    id: 2,
    nome: 'Patricia Almeida',
    profissao: 'VP Global · Setor Financeiro',
    cidade: 'Rio de Janeiro, RJ',
    resultado: 'Promovida a VP Global em 6 meses',
    resultadoIcone: 'ri-line-chart-line',
    depoimento: 'Tinha síndrome da impostora severa. Sentia que estava sempre no lugar errado, esperando ser "descoberta". Com a técnica Swish e a ressignificação da Bia, virei a chave. Recebi a promoção que recusava mentalmente há 3 anos. Parece óbvio, mas não era antes.',
    conquistas: ['Promoção a VP Global', 'Renda triplicada em 12 meses', 'Liderança de equipes internacionais'],
    thumbnail: 'https://readdy.ai/api/search-image?query=elegant%20successful%20executive%20woman%20VP%20corporate%20environment%20dark%20background%20warm%20amber%20tones%20confident%20expression%20professional%20suit%20premium%20office%20setting%20soft%20bokeh%20cinematic%20natural%20authentic%20portrait&width=900&height=506&seq=vid-dep-02-v2&orientation=landscape',
    youtubeId: 'dQw4w9WgXcQ',
    estrelas: 5,
    tempoMetodo: '6 meses no método',
  },
  {
    id: 3,
    nome: 'Ana Paula Costa',
    profissao: 'Médica e Palestrante',
    cidade: 'Belo Horizonte, MG',
    resultado: '50+ palestras internacionais',
    resultadoIcone: 'ri-global-line',
    depoimento: 'Médica com fobia de falar em público. Parece contraditório, mas era minha realidade. A Bia usou PNL clínica pra ressignificar experiências da infância que eu nem lembrava. Hoje sou palestrante em 4 países. O Caderno de Gratidão foi meu ponto de virada.',
    conquistas: ['Palestrante em 4 países', '10.000+ pessoas impactadas', 'Livro publicado pela Editora Record'],
    thumbnail: 'https://readdy.ai/api/search-image?query=professional%20woman%20speaker%20doctor%20elegant%20stage%20warm%20sophisticated%20lighting%20dark%20toned%20background%20premium%20conference%20hall%20cinematic%20photography%20genuine%20confident%20expression%20authentic%20natural%20beauty&width=900&height=506&seq=vid-dep-03-v2&orientation=landscape',
    youtubeId: 'dQw4w9WgXcQ',
    estrelas: 5,
    tempoMetodo: '11 meses no método',
  },
  {
    id: 4,
    nome: 'Camila Ferreira',
    profissao: 'Empreendedora Digital',
    cidade: 'Florianópolis, SC',
    resultado: 'Saiu do burnout, criou negócio de 6 dígitos',
    resultadoIcone: 'ri-heart-pulse-line',
    depoimento: 'Estava em burnout total, chorando toda segunda-feira antes de abrir o notebook. Encontrei o método no pior momento da minha vida profissional. Os exercícios de PNL me deram ferramentas que nenhum psicólogo tinha me dado antes. Saí do colapso e criei meu negócio digital.',
    conquistas: ['Recuperação total do burnout', 'Lançamento de infoproduto 6 dígitos', 'Agenda saudável e sustentável'],
    thumbnail: 'https://readdy.ai/api/search-image?query=young%20professional%20woman%20entrepreneur%20happy%20confident%20light%20casual%20environment%20home%20office%20warm%20natural%20light%20genuine%20smile%20authentic%20modern%20contemporary%20portrait%20photography%20beautiful%20relaxed&width=900&height=506&seq=vid-dep-04-v2&orientation=landscape',
    youtubeId: 'dQw4w9WgXcQ',
    estrelas: 5,
    tempoMetodo: '4 meses no método',
  },
];

const stats = [
  { numero: '10.247', label: 'Vidas transformadas', icon: 'ri-group-line', cor: 'text-gold-400' },
  { numero: '95%', label: 'Satisfação total', icon: 'ri-heart-fill', cor: 'text-gold-400' },
  { numero: '8.5k', label: 'Vitórias registradas', icon: 'ri-trophy-line', cor: 'text-gold-400' },
  { numero: '4.9/5', label: 'Avaliação média', icon: 'ri-star-fill', cor: 'text-gold-400' },
];

export default function VideoDepoimentosHome() {
  const [atualIdx, setAtualIdx] = useState(0);
  const [modalAberto, setModalAberto] = useState(false);

  const atual = depoimentos[atualIdx];

  const abrirModal = () => setModalAberto(true);
  const fecharModal = () => setModalAberto(false);

  return (
    <section className="py-28 bg-[#070707] relative overflow-hidden">
      {/* Decoração de fundo */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/10 to-transparent" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_70%_30%,rgba(201,164,64,0.06),transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_20%_80%,rgba(201,164,64,0.04),transparent_50%)]" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">

        {/* Header */}
        <ScrollRevealWrapper animation="fade-up">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-4 mb-6">
              <div className="h-px w-12 bg-gradient-to-r from-transparent to-gold-500/50" />
              <span className="text-gold-400 text-xs font-semibold tracking-[0.35em] uppercase font-['Montserrat']">
                Prova Social Real
              </span>
              <div className="h-px w-12 bg-gradient-to-l from-transparent to-gold-500/50" />
            </div>
            <h2 className="font-display text-5xl md:text-6xl font-bold text-white mb-4 leading-tight">
              Quem já<br />
              <span className="text-gold-400">transformou a vida</span>
            </h2>
            <p className="text-white/45 text-base max-w-xl mx-auto leading-relaxed font-['Montserrat'] font-light">
              Histórias de mulheres reais que saíram dos padrões limitantes e chegaram ao próximo nível
            </p>
          </div>
        </ScrollRevealWrapper>

        {/* Layout principal — player grande + lista lateral */}
        <ScrollRevealWrapper animation="fade-up" delay={0.1}>
          <div className="grid lg:grid-cols-5 gap-6 mb-12">

            {/* Player principal — col 3 */}
            <div className="lg:col-span-3">
              <div className="bg-[#111111] border border-gold-500/15 rounded-2xl overflow-hidden h-full">
                {/* Thumbnail com play */}
                <div className="relative" style={{ aspectRatio: '16/9' }}>
                  <img
                    src={atual.thumbnail}
                    alt={atual.nome}
                    className="w-full h-full object-cover object-top"
                  />
                  {/* Overlay gradiente */}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#111111] via-transparent to-transparent" />
                  <div className="absolute inset-0 bg-gradient-to-r from-[#111111]/30 to-transparent" />

                  {/* Botão Play */}
                  <button
                    onClick={abrirModal}
                    className="absolute inset-0 flex items-center justify-center group cursor-pointer"
                    aria-label="Assistir depoimento"
                  >
                    <div className="relative">
                      <div className="absolute inset-0 rounded-full bg-gold-500/20 scale-110 group-hover:scale-125 transition-transform duration-500 blur-sm" />
                      <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-gold-400 to-gold-700 flex items-center justify-center group-hover:scale-110 transition-transform duration-300 border border-gold-300/30">
                        <i className="ri-play-fill text-[#0a0a0a] text-3xl ml-1" />
                      </div>
                    </div>
                  </button>

                  {/* Badge Resultado */}
                  <div className="absolute top-4 right-4 bg-[#0a0a0a]/80 backdrop-blur-sm border border-gold-500/20 rounded-full px-3 py-1.5 flex items-center gap-1.5">
                    <i className={`${atual.resultadoIcone} text-gold-400 text-xs`} />
                    <span className="text-white/75 text-[11px] font-semibold font-['Montserrat'] whitespace-nowrap">Resultado Comprovado</span>
                  </div>

                  {/* Tempo no método */}
                  <div className="absolute bottom-4 left-4 bg-gold-500/15 border border-gold-500/25 rounded-full px-3 py-1.5 flex items-center gap-1.5 backdrop-blur-sm">
                    <i className="ri-time-line text-gold-400 text-xs" />
                    <span className="text-gold-300 text-[11px] font-semibold font-['Montserrat']">{atual.tempoMetodo}</span>
                  </div>
                </div>

                {/* Info do depoimento */}
                <div className="p-6">
                  <div className="flex items-start justify-between gap-4 mb-4">
                    <div>
                      <h3 className="font-display text-xl font-bold text-white leading-tight">{atual.nome}</h3>
                      <p className="text-gold-400/80 text-sm font-['Montserrat'] mt-0.5">{atual.profissao}</p>
                      <div className="flex items-center gap-1.5 mt-1">
                        <i className="ri-map-pin-line text-white/30 text-xs" />
                        <span className="text-white/30 text-xs font-['Montserrat']">{atual.cidade}</span>
                      </div>
                    </div>
                    <div className="flex gap-0.5 flex-shrink-0">
                      {Array.from({ length: atual.estrelas }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-gold-400 text-sm" />
                      ))}
                    </div>
                  </div>

                  <blockquote className="text-white/55 text-sm leading-relaxed font-['Montserrat'] italic border-l-2 border-gold-500/25 pl-4 mb-5">
                    &ldquo;{atual.depoimento}&rdquo;
                  </blockquote>

                  {/* Conquistas */}
                  <div className="grid grid-cols-1 gap-2">
                    {atual.conquistas.map((c, i) => (
                      <div key={i} className="flex items-center gap-2.5 bg-gold-500/6 border border-gold-500/10 rounded-lg px-3 py-2">
                        <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                          <i className="ri-check-line text-gold-400 text-xs" />
                        </div>
                        <span className="text-white/60 text-xs font-['Montserrat']">{c}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Lista lateral — col 2 */}
            <div className="lg:col-span-2 flex flex-col gap-3">
              <p className="text-white/25 text-xs font-semibold tracking-widest uppercase font-['Montserrat'] mb-1">
                Mais histórias
              </p>
              {depoimentos.map((d, i) => (
                <button
                  key={d.id}
                  onClick={() => setAtualIdx(i)}
                  className={`group w-full text-left rounded-xl overflow-hidden transition-all duration-300 cursor-pointer border ${
                    atualIdx === i
                      ? 'border-gold-500/40 ring-1 ring-gold-400/20 bg-[#1a1400]'
                      : 'border-gold-500/10 bg-[#111111] hover:border-gold-500/25 hover:bg-[#141414]'
                  }`}
                >
                  <div className="flex gap-3 p-3">
                    {/* Mini thumbnail */}
                    <div className="relative w-20 h-14 flex-shrink-0 rounded-lg overflow-hidden">
                      <img
                        src={d.thumbnail}
                        alt={d.nome}
                        className="w-full h-full object-cover object-top"
                      />
                      <div className="absolute inset-0 bg-[#0a0a0a]/40 flex items-center justify-center">
                        <div className={`w-7 h-7 rounded-full flex items-center justify-center transition-colors ${
                          atualIdx === i ? 'bg-gold-500' : 'bg-white/20 group-hover:bg-gold-500/70'
                        }`}>
                          <i className="ri-play-fill text-white text-xs ml-0.5" />
                        </div>
                      </div>
                    </div>

                    {/* Info */}
                    <div className="flex-1 min-w-0">
                      <p className={`font-display font-bold text-sm leading-tight mb-0.5 transition-colors ${
                        atualIdx === i ? 'text-gold-400' : 'text-white/80 group-hover:text-white'
                      }`}>
                        {d.nome}
                      </p>
                      <p className="text-white/35 text-xs font-['Montserrat'] mb-1.5 truncate">{d.profissao}</p>
                      <div className="flex items-center gap-1.5">
                        <div className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${atualIdx === i ? 'bg-gold-400' : 'bg-white/20'}`} />
                        <p className={`text-[11px] font-['Montserrat'] font-medium leading-tight transition-colors ${
                          atualIdx === i ? 'text-gold-400/80' : 'text-white/40'
                        }`}>
                          {d.resultado}
                        </p>
                      </div>
                    </div>
                  </div>
                </button>
              ))}

              {/* Card de CTA lateral */}
              <div className="mt-auto bg-gradient-to-br from-[#1a1400] to-[#0f0c00] border border-gold-500/20 rounded-xl p-5">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-7 h-7 flex items-center justify-center">
                    <i className="ri-quill-pen-line text-gold-400" />
                  </div>
                  <span className="text-white/80 text-sm font-bold font-['Montserrat']">Próxima história?</span>
                </div>
                <p className="text-white/40 text-xs font-['Montserrat'] leading-relaxed mb-4">
                  Mais de 10.000 mulheres já transformaram suas vidas. Sua vez pode ser agora.
                </p>
                <a
                  href="/planos"
                  className="flex items-center justify-center gap-2 w-full px-4 py-2.5 bg-gradient-to-r from-gold-500 to-gold-700 text-[#0a0a0a] text-xs font-bold rounded-full hover:from-gold-400 hover:to-gold-600 transition-all whitespace-nowrap font-['Montserrat'] tracking-wide"
                >
                  Começar minha jornada
                  <i className="ri-arrow-right-line text-sm" />
                </a>
              </div>
            </div>
          </div>
        </ScrollRevealWrapper>

        {/* Stats */}
        <ScrollRevealWrapper animation="fade-up" delay={0.2}>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-12">
            {stats.map((s, i) => (
              <div
                key={i}
                className="bg-[#111111] border border-gold-500/10 rounded-xl p-5 text-center group hover:border-gold-500/25 transition-colors"
              >
                <div className="w-9 h-9 flex items-center justify-center mx-auto mb-3">
                  <i className={`${s.icon} ${s.cor} text-xl`} />
                </div>
                <div className="font-display text-3xl font-bold text-gold-400 mb-1">{s.numero}</div>
                <div className="text-white/35 text-xs font-['Montserrat']">{s.label}</div>
              </div>
            ))}
          </div>
        </ScrollRevealWrapper>

        {/* Social proof strip */}
        <ScrollRevealWrapper animation="fade-up" delay={0.3}>
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 py-7 border-t border-b border-gold-500/10">
            {[
              { icon: 'ri-instagram-line', texto: '48k seguidoras no Instagram', cor: 'text-pink-400' },
              { icon: 'ri-shield-check-line', texto: 'Método certificado em PNL Clínica', cor: 'text-green-400' },
              { icon: 'ri-award-line', texto: 'Reconhecida como top coach 2024', cor: 'text-gold-400' },
              { icon: 'ri-verified-badge-line', texto: 'Resultados verificados por clientes reais', cor: 'text-gold-400' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${item.icon} ${item.cor} text-base`} />
                </div>
                <span className="text-white/40 text-xs font-['Montserrat']">{item.texto}</span>
              </div>
            ))}
          </div>
        </ScrollRevealWrapper>
      </div>

      {/* Modal de Vídeo */}
      {modalAberto && (
        <div
          className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={fecharModal}
        >
          <div
            className="relative w-full max-w-4xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Fechar */}
            <button
              onClick={fecharModal}
              className="absolute -top-12 right-0 w-10 h-10 flex items-center justify-center text-white/60 hover:text-white transition-colors cursor-pointer"
              aria-label="Fechar"
            >
              <i className="ri-close-line text-2xl" />
            </button>

            {/* Player iframe */}
            <div className="relative bg-[#0a0a0a] rounded-2xl overflow-hidden border border-gold-500/20" style={{ aspectRatio: '16/9' }}>
              <iframe
                src={`https://www.youtube.com/embed/${atual.youtubeId}?autoplay=1&rel=0`}
                title={`Depoimento de ${atual.nome}`}
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>

            {/* Créditos abaixo do player */}
            <div className="mt-4 flex items-center justify-between px-1">
              <div>
                <p className="text-white font-display font-bold">{atual.nome}</p>
                <p className="text-gold-400/70 text-sm font-['Montserrat']">{atual.profissao} · {atual.cidade}</p>
              </div>
              <div className="text-right">
                <p className="text-white/40 text-xs font-['Montserrat']">Resultado</p>
                <p className="text-gold-400 text-sm font-semibold font-['Montserrat']">{atual.resultado}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
